import { parseDate } from "../../com/dateUtil";

const url = "/location";

export const setLocation = async (conn, data) => {
  const { userId, lat, lng, address } = data;

  const params = {
    userId: userId,
    gathDtm: parseDate("yyyy-mm-dd hh:mm:ss", new Date()),
    lat: lat,
    lng: lng,
    address: address,
  };

  const response = await conn.post(url, params);

  return response;
};


export const getLocation = async (conn, data) => {

  const { userId } = data;

  const config = {
    params: {
      userId: userId,
      searchDtm: parseDate("yyyy-mm-dd", new Date()),
    },
  };

  const response = await conn.get(url, config);

  return response;
};
